import { useEffect, useState } from "react";
import { useWrapRequest } from "utils";
import { getExistingCustomerKickoutPage } from "services/get-getExistingCustomerKickoutPage";
import { cartState, isExistingCustomerState } from "atoms";
import { useSetRecoilState } from "recoil";
import { useSearchParams } from "react-router-dom";
import { ResponseObject } from "atoms/models";

const Ekick = () => {
  const wrapRequest = useWrapRequest();
  const setCart = useSetRecoilState(cartState);
  const [kickMessage, setKickMessage] = useState("");
  const [searchParams] = useSearchParams();
  const setIsExistingCustomer = useSetRecoilState(isExistingCustomerState);

  useEffect(() => {
    let kickoutBillId: string | null;
    let kickoutReason: string | null;
    const fetchUrlParams = () => {
      kickoutBillId = searchParams.get("billId");
      kickoutReason = searchParams.get("reason");
    };
    fetchUrlParams();

    wrapRequest(async () => {
      let getExistingCustomerKickoutPageResponse: ResponseObject | undefined;
      if (kickoutBillId && kickoutReason) {
        getExistingCustomerKickoutPageResponse = await getExistingCustomerKickoutPage(kickoutBillId, kickoutReason);
        setIsExistingCustomer(true);
      }

      if (getExistingCustomerKickoutPageResponse?._embedded) {
        const cart = getExistingCustomerKickoutPageResponse._embedded["ec:cart"];
        const kickMessage = getExistingCustomerKickoutPageResponse._embedded["ec:errorHtml"];

        if (cart) {
          setCart(cart);
        }

        if (kickMessage) {
          setKickMessage(kickMessage);
        }
      }
    });
    // eslint-disable-next-line
  }, [searchParams, setCart]);

  const activateChatClick = () => {
    const chatClickElement = document.querySelector(".helpButtonEnabled") as HTMLElement;

    if (chatClickElement) {
      chatClickElement.click();
    }
  };

  return (
    <div className="ekick-container text-center">
      <div dangerouslySetInnerHTML={{ __html: kickMessage }} className="mt-5 mb-5" />
      <h3 className="mb-5">Or</h3>
      <h3>
        <button className="chat-now-button" onClick={() => activateChatClick()}>
          Chat Now
        </button>
      </h3>
    </div>
  );
};

export default Ekick;
